export default "__VITE_ASSET__CD_SbNUz__"